module.exports = __webpack_public_path__ + "static/media/depression_severe.45f3a48f.svg";